module.exports = __webpack_public_path__ + "img/6554691.ccc4ac2b.png";